module.exports = __webpack_public_path__ + "img/compact.c58a80da.png";